<ng-container *transloco="let t">

  <div class="container pb-5 pt-2">

    @if (isPreview() && !isPublic()) {
      <div class="row">
        <div class="col-12 my-2">
          <div class="alert alert-secondary" role="alert">
            <p class="lead">
              <lucide-icon [img]="icons.info"></lucide-icon>
              Bienvenue sur le profil de <em>{{ h()?.name }}</em>.
            </p>
            <p class="lead my-2">
              Présente ton organisation et rends-la attrayante en ajoutant une photo, une description
              et des liens vers votre site internet et vos réseaux sociaux.
            </p>
            <p class="lead mt-2">
              Toutes les activités que tu publie pour {{ h()?.name }} seront aussi visibles ici.
            </p>
          </div>
        </div>
      </div>

      @if (improveMessages().length > 0) {
        <div class="row my-2">
          <div class="col-12">
            <div class="alert alert-warning">
              <lucide-icon [img]="icons.improve"></lucide-icon> Cette organisation peut être améliorée:
              <ul class="my-0">
                @for (message of improveMessages(); track message) {
                  <li>{{ message }}</li>
                }
              </ul>
            </div>
          </div>
        </div>
      }
    }

    <div class="row">
      <div class="col">
        <p class="text-center mb-2 text-black text-opacity-25">
          informations fournies sans garanties
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <h3 class="text-secondary">{{ h()?.name ?? 'Nouvelle organisation' }}</h3>
        <p>
          <span class="host-type">{{ h()?.legalForm | legalForm }}</span>
        </p>
      </div>
    </div>

    @if (h()?.cover) {
      <app-cover-viewer
        [url]="coverUrl"
        [thumbnailUrl]="coverThumbnailUrl">
      </app-cover-viewer>
    }

    <div class="row my-2">
      <div class="col-12 ml-description">
        {{ h()?.description }}
      </div>
    </div>

    <div class="row my-3">
      <div class="col-12">
        <h3 class="text-secondary">
          <app-activity-type-icon [type]="activityTypes.Activity"></app-activity-type-icon>
          Activités
        </h3>
      </div>
    </div>
    @if (isPreview()) {

      @if (hasNoActivities()) {
        <p>
          Montre le dynamisme de {{ hostName() }} en publiant une première activité:
        </p>
      }

      <div class="row my-3">
        <div class="col-12">
          <button (click)="createNewActivity()" class="btn btn-outline-primary">
            <lucide-icon [img]="icons.publish"></lucide-icon>
            {{ t('activity.dashboard.btnPublish') }}
          </button>
        </div>
      </div>
    }
    <app-activities-preview
      [items]="activities()"
      [isPublic]="isPublic()"
      [showUnpublished]="true">
    </app-activities-preview>

    @if (events().length > 0) {
      <div class="row my-3">
        <div class="col-12">
          <h3 class="text-secondary">
            <app-activity-type-icon [type]="activityTypes.Event"></app-activity-type-icon>
            Événements
          </h3>
        </div>
      </div>
      <app-activities-preview
        [items]="events()"
        [isPublic]="isPublic()"
        [showUnpublished]="true">
      </app-activities-preview>
    }

    <div class="row mt-3">
      <div class="col-12">
        <h3 class="text-secondary">
          <lucide-icon [img]="icons.contact"></lucide-icon>
          Contact
        </h3>
      </div>
    </div>
    <div class="row">
      @if (isPreview()) {
        <div class="col">
        @if (!hasContactInfo()) {
          <button type="button" class="btn btn-sm btn-primary my-2" (click)="navigateToEditContact()">
            <lucide-icon [img]="icons.edit"></lucide-icon>
            Indiquer les informations de contact
          </button>
        } @else {
          <app-host-contact-note [host]="h()"></app-host-contact-note>
        }
        </div>
      }
      <div class="col-12 my-2 links">
        @if (h()?.webUrl) {
          <a [href]="h()?.webUrl"
             target="_blank"
             class="me-3"
             rel="noopener noreferrer">
            web
            <lucide-icon [img]="icons.externalLink"></lucide-icon>
          </a>
        }
        @if (h()?.fbUrl) {
          <a [href]="h()?.fbUrl"
             target="_blank"
             class="me-3"
             rel="noopener noreferrer">
            facebook
            <lucide-icon [img]="icons.externalLink"></lucide-icon>
          </a>
        }
        @if (h()?.igUrl) {
          <a [href]="h()?.igUrl"
             target="_blank"
             class="me-3"
             rel="noopener noreferrer">
            instagram
            <lucide-icon [img]="icons.externalLink"></lucide-icon>
          </a>
        }

        @if (h()?.messaging) {
          <button type="button" class="btn btn-link" (click)="toggleShowContact()">
            Écrire un message
            <lucide-icon [img]="icons?.message"></lucide-icon>
          </button>
        }
      </div>
    </div>

    <section [appScrollTarget]="SECTION_SEND_MESSAGE">
      @if (showContact()) {
        <app-host-contact-form
          [host]="h()"
          [isPreview]="isPreview()"
          (cancelled)="toggleShowContact()">
        </app-host-contact-form>
      }
    </section>
  </div>

</ng-container>
